// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6638) return "static/chunks/6638.4eca40bc82a50169.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"3410":"dfe826f750709a99","5549":"b3bc47101f91a447","8882":"10cb6a7c63b72d2e"}[chunkId] + ".js";
};